export const isAbsolutePath = (url: string) => {
  return url.includes('http');
};
